module.exports = __webpack_public_path__ + "img/11.7b1bf34d.jpg";